import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HeaderModule } from '../shared/header/header.module';
import { FooterModule } from '../shared/footer/footer.module';
import { NoteDetailedModule } from '../shared/note-detailed/note-detailed.module';
import { RelatedNotesModule } from '../shared/related-notes/related-notes.module';

import {NoteDetailsComponent} from './note-details.component';
import { CreatorCallToActionModule } from '../creator-call-to-action/creator-call-to-action.module';

@NgModule({
    declarations: [ NoteDetailsComponent ],
    imports: [
        RouterModule.forChild([{ path: '', component: NoteDetailsComponent }]),
        CommonModule,
        HeaderModule,
        FooterModule,
        NoteDetailedModule,
        RelatedNotesModule,
        CreatorCallToActionModule
    ],
    exports: [ NoteDetailsComponent ]
})

export class NoteDetailsModule {}
